import * as React from 'react';
import PropTypes from 'prop-types';

import LoginGoogleButtonElectron from '../cross-platform/login/LoginGoogle.button.electron';
import LoginGoogleButtonWeb from '../cross-platform/login/LoginGoogle.button.web';

const propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired
};

/** Electron */
let electronVersion = props => {
  return <LoginGoogleButtonElectron onSuccess={props.onSuccess} onFailure={props.onFailure} />;
};
electronVersion.propTypes = propTypes;

/** Web */
let webVersion = props => {
  return <LoginGoogleButtonWeb onSuccess={props.onSuccess} onFailure={props.onFailure} />;
};
webVersion.propTypes = propTypes;

/**
 * MAIN
 */
let versions = {
  electron: electronVersion,
  web: webVersion
};

export let LoginGoogleButton;
export let configure = mode => {
  LoginGoogleButton = versions[mode];
};
